/**
 * Module dependencies.
 */

import { Company } from 'types/company';
import { ContactsDescription, ContactsSection } from './contacts.style';
import { ContactsForm } from 'components/molecules/contacts-form/contacts-form';
import { ContactsHeader } from 'components/molecules/contacts-header/contacts-header';
import { ContactsInfo } from 'components/molecules/contacts-info/contacts-info';
import { Footer } from 'components/molecules/footer/footer';
import { JSX } from 'react';
import { Language } from 'types/language';
import { PageContainer } from 'components/atoms/page-container/page-container';
import { Title } from 'components/atoms/title/title';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  company: Company;
  languages: Language[];
  socialNetworks: Record<string, string>;
};

export function Contacts(props: Props): JSX.Element {
  const { company, languages, socialNetworks } = props;
  const [translate] = useTranslation();

  return (
    <>
      <ContactsHeader />

      <PageContainer>
        <Title center>{translate('contacts.title')}</Title>

        <ContactsDescription>
          {translate('contacts.description')}
        </ContactsDescription>

        <ContactsSection>
          <ContactsForm />

          <ContactsInfo company={company} languages={languages} />
        </ContactsSection>
      </PageContainer>

      <Footer socialNetworks={socialNetworks} />
    </>
  );
}
